import { isEmpty } from '@app/utils/isEmpty';
import { Order } from '@typings';
import { useTranslation } from 'react-i18next';

import { CheckoutOrderOverview } from './CheckoutOrderOverview';
import { SplitHeader } from './SplitRow';

interface Props {
  orderDetails: Order.Single;
}

export const CheckoutOrdersSplit = ({ orderDetails }: Props) => {
  const { t } = useTranslation(['common', 'totals', 'products']);

  const splitOrders = orderDetails.splitOrders ?? [];
  const orders = !isEmpty(splitOrders) ? splitOrders : [orderDetails.order];

  return (
    <div>
      <SplitHeader>
        <div className="-ml-4 heading-3">{t('products:product_other')}</div>
        <div className="invisible text-center text-neutral-40 heading-4 sm:visible">{t('common:unit_other')}</div>
        <div className="invisible whitespace-nowrap text-right text-neutral-40 heading-4 sm:visible">{t('totals:total_no_tax')}</div>
      </SplitHeader>

      <div className="mt-2 flex flex-col gap-2 overflow-hidden">
        {orders.map((order, index) => (
          <CheckoutOrderOverview
            key={order.order}
            orderIndex={orders.length > 1 ? index + 1 : undefined}
            order={order}
            products={orderDetails.products}
          />
        ))}
      </div>
    </div>
  );
};
